import type {} from "@mui/x-data-grid/themeAugmentation"

export const MuiDataGrid = {
    styleOverrides: {
        root: {
            background: "#fff",
            borderRadius: 10,
            fontFamily: "'Roboto'",
            fontSize: 12,
            p: {
                fontSize: "12px",
            },
            span: {
                fontSize: "12px",
            },
            ".MuiDataGrid-columnHeaderTitle": {
                overflow: "auto",
                lineHeight: "normal",
                whiteSpace: "normal",
            },
            ".MuiDataGrid-columnHeaderTitleContainer": {
                overflow: "auto",
                whiteSpace: "normal",
                lineHeight: " normal",
            },
            ".MuiDataGrid-cell": {
                whiteSpace: "normal !important",
                display: "flex",
                alignItems: "center",
            },
            ".MuiDataGrid-cell:focus": {
                outline: "none",
            },
            ".MuiDataGrid-cell:focus-within": {
                outline: "none",
            },
            ".MuiDataGrid-row:hover": {
                background: "rgba(0 0 0 / 2%)",
            },
            ".MuiDataGrid-columnHeader:focus, .MuiDataGrid-cell:focus": {
                outline: "none",
            },
            ".MuiDataGrid-footerContainer": {
                backgroundColor: "#F9F9F9",
                borderBottomLeftRadius: "8px",
                borderBottomRightRadius: "8px",
            },
        },
    },
}
